import React from "react";
import styles from "../../styles/loading.module.scss";

import classNames from "classnames/bind";
import globals from "../../styles/globals.scss";

export const Loading = ({
  size = 13,
  color = globals.primaryColor,
  fullContent = false,
  fullScreen = false,
  onboarding = false,
  style,
}) => {
  const cx = classNames.bind(styles);

  const dotStyle = {
    height: size,
    width: size,
    background: color,
  };

  if (onboarding) {
    return (
      <div
        className={cx({
          onboarding: true,
        })}
        style={style}
      >
        <div
          className={styles["lds-ellipsis"]}
          style={{ height: size, width: size * 6 }}
        >
          <div style={dotStyle}></div>
          <div style={dotStyle}></div>
          <div style={dotStyle}></div>
          <div style={dotStyle}></div>
        </div>
      </div>
    );
  }

  if (fullContent || fullScreen) {
    return (
      <div
        className={cx({
          "content-load": true,
          "full-loading": fullScreen,
          "full-content": fullContent,
        })}
      >
        <div
          className={styles["lds-ellipsis"]}
          style={{ height: size, width: size * 6 }}
        >
          <div style={dotStyle}></div>
          <div style={dotStyle}></div>
          <div style={dotStyle}></div>
          <div style={dotStyle}></div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={styles["lds-ellipsis"]}
      style={{ height: size, width: size * 6 }}
    >
      <div style={dotStyle}></div>
      <div style={dotStyle}></div>
      <div style={dotStyle}></div>
      <div style={dotStyle}></div>
    </div>
  );
};
